import React from "react";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { Pressable, Text, View } from "react-native";
import { GlobalStyles, Transition } from "../style/Style";
interface ButtonProps {
    buttonText: string;
    isActive: boolean;
    icon: JSX.Element;
    onPress: () => void;
}

export const NavigationButton: React.FC<ButtonProps> = ({ buttonText, isActive = false, icon, onPress }) => {
    const styles = useDynamicStyles(generateStyles);
    const active = isActive ? styles.active : {};

    return (
        <Pressable style={styles.button} onPress={onPress}>
            <View style={[styles.buttonInfoContainer, active, Transition()]}>
                {icon}
                <Text style={[styles.buttonText]}>{buttonText}</Text>
            </View>
        </Pressable>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        button: {
            width: "100%",
            height: 50,
            borderRadius: 25,
            flexShrink: 1,
        },
        buttonInfoContainer: {
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            opacity: 0.4,
        },
        buttonText: {
            color: () => EStyleSheet.value(GlobalStyles.NAVIGATION_BUTTON_TEXT),
            fontFamily: () => EStyleSheet.value(GlobalStyles.BASE_FONT),
            fontSize: 12,
            lineHeight: 12,
            textAlign: "center",
        },
        active: {
            opacity: 1,
        },
    });
};
